module.exports = __webpack_public_path__ + "img/LUB00003.98cd6a21.png";